<template>
  <Popover ref="popover" :showHeader="true" :headerTitle="title" placement="top">
    <div class="measure-popoper">
      <div class="row no-gutters">
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.left, HoleMeasurePointTypes.top)}]" @click.prevent="clickButton(HoleMeasurePointTypes.left, HoleMeasurePointTypes.top)"><i class="far fa-arrow-alt-up" :style="arrowRotation(315)" /></button></div>
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.center, HoleMeasurePointTypes.top)}]" @click.prevent="clickButton(HoleMeasurePointTypes.center, HoleMeasurePointTypes.top)"><i class="far fa-arrow-alt-up" /></button></div>
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.right, HoleMeasurePointTypes.top)}]" @click.prevent="clickButton(HoleMeasurePointTypes.right, HoleMeasurePointTypes.top)"><i class="far fa-arrow-alt-up" :style="arrowRotation(45)" /></button></div>      
      </div>
      <div class="row no-gutters">
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.left, HoleMeasurePointTypes.middle)}]" @click.prevent="clickButton(HoleMeasurePointTypes.left, HoleMeasurePointTypes.middle)"><i class="far fa-arrow-alt-up" :style="arrowRotation(270)" /></button></div>
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.center, HoleMeasurePointTypes.middle)}]" @click.prevent="clickButton(HoleMeasurePointTypes.center, HoleMeasurePointTypes.middle)"><i class="far fa-plus" /></button></div>
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.right, HoleMeasurePointTypes.middle)}]" @click.prevent="clickButton(HoleMeasurePointTypes.right, HoleMeasurePointTypes.middle)"><i class="far fa-arrow-alt-up" :style="arrowRotation(90)" /></button></div>      
      </div>
      <div class="row no-gutters">
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.left, HoleMeasurePointTypes.bottom)}]" @click.prevent="clickButton(HoleMeasurePointTypes.left, HoleMeasurePointTypes.bottom)"><i class="far fa-arrow-alt-up" :style="arrowRotation(225)" /></button></div>
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.center, HoleMeasurePointTypes.bottom)}]" @click.prevent="clickButton(HoleMeasurePointTypes.center, HoleMeasurePointTypes.bottom)"><i class="far fa-arrow-alt-up" :style="arrowRotation(180)" /></button></div>
        <div class="col-4"><button :class="['btn', 'btn-block', 'btn-default', {'measure-selected': isPointSelected(HoleMeasurePointTypes.right, HoleMeasurePointTypes.bottom)}]" @click.prevent="clickButton(HoleMeasurePointTypes.right, HoleMeasurePointTypes.bottom)"><i class="far fa-arrow-alt-up" :style="arrowRotation(135)" /></button></div>      
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.arrow-top-left {
  -webkit-transform: rotate(315deg);
  -ms-transform: rotate(315deg);
  transform: rotate(315deg);
}
.measure-popoper {
  padding: 0.5rem 0;
}
.measure-popoper button {
  width: 40px;
  height: 40px;
  font-size: 1.0rem;
  margin: 0.2rem;
}
button.measure-selected {
  color: #009000;
}
button.measure-selected > i{
  font-weight: 900;
}

</style>


<script>
import Popover from '@/components/popover.vue'
import { HoleMeasurePointTypes } from '@glass-designer/types'

export default {
  name: 'EditorMeasureToPopover',
  model: {
    event: 'update'
  },
  components: {
    Popover
  },
  props: {
    title: {
      type: String,
      default: 'Options'
    },
    horizontalValue: String,
    verticalValue: String
  },
  created() {
    this.HoleMeasurePointTypes = HoleMeasurePointTypes
  },
  methods: {
    displayFromElement(element) {
      this.$refs.popover.displayFromElement(element)
    },
    arrowRotation(angle) {
      return {
        '-webkit-transform': `rotate(${angle}deg)`,
        '-ms-transform': `rotate(${angle}deg)`,
        'transform': `rotate(${angle}deg)`
      }
    },
    clickButton(horizontalValue, verticalValue) {
      this.$emit('updateHorizontal', horizontalValue)
      this.$emit('updateVertical', verticalValue)
      this.$refs.popover.hidePopover()
    },
    isPointSelected(horizontalValue, verticalValue) {
      return this.horizontalValue == horizontalValue && this.verticalValue == verticalValue
    }
    
  }
}
</script>
